import { motion } from 'framer-motion';
import Reveal from '@/components/common/Reveal';

const testimonials = [
  {
    quote: "TechsFlow transformed our digital presence. The website is sleek, professional, and captures the premium feel of our institute perfectly.",
    author: "Dr. Sonal Dorkhande",
    clinic: "Founder of Aurederma Institute, Nagpur"
  },
  {
    quote: "TechsFlow helped me establish a strong online presence for my practice in Loni Takli. The new website is clean, informative, and has made it much easier for new patients in the area to find my clinic and connect with me.",
    author: "Dr. Nitin Ingole",
    clinic: "Vithhal Mauli Clinic, Loni Takli, Amravati"
  },
  {
    quote: "The website is mobile-friendly and easy for patients to use. Anamat understood exactly what a clinic website needs — clear services, easy contact, and a professional look.",
    author: "Dr. Dnyaneshwar Kadam",
    clinic: "Aarogya Clinic, Pune"
  }
];

export const Testimonials = () => (
  <section className="py-24 md:py-32 bg-secondary/30">
    <div className="mx-auto container-editorial">
      <Reveal className="mb-16">
        <div className="label-eyebrow mb-4">Chapter — Client Notes</div>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-balance max-w-2xl">
          Don't just take <span className="italic-serif text-sienna">our word for it.</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
        {testimonials.map((t, i) => (
          <Reveal key={i} delay={i * 0.15} className="flex flex-col h-full">
            <div className="card-editorial p-8 md:p-10 flex flex-col h-full bg-background/50">
              <svg className="w-8 h-8 text-sienna/30 mb-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>
              <blockquote className="font-serif text-xl md:text-2xl leading-relaxed text-foreground/90 mb-8 flex-1">
                "{t.quote}"
              </blockquote>
              <div className="mt-auto">
                <div className="font-medium text-foreground">{t.author}</div>
                <div className="text-sm text-muted-foreground mt-1">{t.clinic}</div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
